import React, { Component } from "react";
import ClearFilterButton from "../../components/ClearFilterButton.js";
import { formatNumber } from "../../utils/formatting";
import {
  loading,
  alert,
  NavbarAdmin,
  Pagination,
  Modal,
  Select,
  Status,
  DateRangeFields,
  currentLang,
  GET,
  GET_FILE,
  profile,
  t,
} from "../../components/CustomComponent.js";

const PAGE_SIZE = 10;

const TH_MONTHS = ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."];
const EN_MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// สถานะรายงาน: signed = ลงนามครบ, pending_signature = รอลายเซ็นลูกค้า (ไม่มีสถานะ "ออกรายงานใหม่" ตามที่ผู้ใช้ตัดสิน)
const STATUS_MAP = {
  signed: { label: "pcmr_status_signed", color: "success" },
  pending_signature: { label: "pcmr_status_pending_signature", color: "warning" },
};

// รายงานดูแลสระประจำเดือน - 1 แถว = 1 โครงการ(สระ) x 1 เดือน ที่มีการเข้าบริการจริง
//   GET admin/pool-care-monthly-reports/options     -> customers + projects (กรอง dropdown)
//   GET admin/pool-care-monthly-reports             -> list + pagination
//   GET admin/pool-care-monthly-reports/pdf         -> PDF รายแถว (GET_FILE -> blob URL เปิดแท็บใหม่)
//   GET admin/pool-care-monthly-reports/batch-plan  -> แผนแบ่งไฟล์ Print ทั้งหมด (ไฟล์ละ <= chunk_size)
//   GET admin/pool-care-monthly-reports/batch-pdf   -> PDF ของไฟล์ที่ chunk_index
const API = "admin/pool-care-monthly-reports";

export default class AdminPoolCareMonthlyReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",
      filter_customer_id: "",
      filter_asset_id: "",
      filter_date_start: "", // YYYY-MM-DD - แสดงรายงานทุกเดือนที่ช่วงวันที่ทับซ้อน (ใส่ปลายเดียวได้)
      filter_date_end: "",

      data: [],
      count: 0,
      page: 1,

      options_customers: [],
      options_projects: [],

      modal_batch: false,
      batch_plan: null,
      batch_total: 0, // จำนวนรายงานที่พิมพ์ได้จริงตาม batch-plan (ไม่รวมแถว can_print=false)
    };
  }

  async componentDidMount() {
    loading(false);
    await this.GetOptions();
    this.Get(1);
  }

  // super_user / admin-company ข้ามการตรวจสิทธิ์ระดับหน้าเหมือน PermissionRoute (mileage.js ใช้ pattern เดียวกัน)
  hasPermission = (key) => {
    if (["super_user", "admin-company"].includes(profile?.user_type)) return true;
    return (profile?.role?.permission || []).includes(key);
  };

  GetOptions = async () => {
    const result = await GET(`${API}/options`);
    if (result?.status) {
      this.setState({
        options_customers: (result.data?.customers || []).map((c) => ({
          value: c.uid,
          label: [c.customer_code, c.name].filter(Boolean).join(" - "),
        })),
        options_projects: (result.data?.projects || []).map((p) => ({
          value: p.asset_uid,
          customer_uid: p.customer_uid,
          label: [p.asset_code, p.name].filter(Boolean).join(" – "),
        })),
      });
    }
  };

  // พารามิเตอร์กรองชุดเดียวกันทั้ง list / batch-plan / batch-pdf
  getFilterParams = () => {
    const { filter_search, filter_customer_id, filter_asset_id, filter_date_start, filter_date_end } = this.state;
    return {
      data_search: filter_search || "",
      customer_id: filter_customer_id || "",
      asset_id: filter_asset_id || "",
      date_start: filter_date_start || "",
      date_end: filter_date_end || "",
    };
  };

  Get = async (page) => {
    loading(true);
    const params = this.getFilterParams();
    const canExport = this.hasPermission("pool_care_report.export");
    const [result, planResult] = await Promise.all([
      GET(`${API}`, { page, page_size: PAGE_SIZE, ...params }),
      // ตัวเลขบนปุ่ม Print ทั้งหมดต้องมาจาก batch-plan (นับเฉพาะที่พิมพ์ได้) ฟิลเตอร์ชุดเดียวกับ list
      canExport ? GET(`${API}/batch-plan`, params, true, { skipAccessDeniedAlert: true }) : Promise.resolve(null),
    ]);
    const batchPlan = planResult?.status && planResult.data ? planResult.data : null;

    if (result?.status) {
      this.setState({
        data: result.data || [],
        count: result.pagination?.count || 0,
        page,
        batch_plan: batchPlan,
        batch_total: batchPlan?.total || 0,
      });
    } else {
      this.setState({ data: [], count: 0, page, batch_plan: null, batch_total: 0 });
      if (result?.message) alert("", "warning", t("warning"), result.message);
    }
    loading(false);
  };

  ResetFilter = () => {
    this.setState(
      { filter_search: "", filter_customer_id: "", filter_asset_id: "", filter_date_start: "", filter_date_end: "" },
      () => this.Get(1)
    );
  };

  // เปิด PDF ที่ได้จาก GET_FILE ในแท็บใหม่ (เปิดแท็บก่อน await กัน popup blocker)
  OpenPdf = async (path, params) => {
    const win = window.open("", "_blank");
    loading(true);
    const result = await GET_FILE(path, params);
    loading(false);

    if (result?.status && result.blob) {
      const blobUrl = URL.createObjectURL(result.blob);
      if (win) win.location.href = blobUrl;
      else window.open(blobUrl, "_blank");
      setTimeout(() => URL.revokeObjectURL(blobUrl), 120000);
    } else {
      if (win) win.close();
      alert("", "warning", t("warning"), result?.message || t("pcmr_pdf_failed"));
    }
  };

  PrintRow = (item) => {
    this.OpenPdf(`${API}/pdf`, { asset_id: item.project?.asset_uid || "", month: item.month || "" });
  };

  OpenBatch = () => {
    if (!this.state.batch_plan?.total) return;
    this.setState({ modal_batch: true });
  };

  PrintBatchFile = (file) => {
    this.OpenPdf(`${API}/batch-pdf`, { ...this.getFilterParams(), chunk_index: file.index });
  };

  // "2026-08" -> "ส.ค. 2026" / "Aug 2026"
  formatMonth = (value) => {
    const match = typeof value === "string" && value.match(/^(\d{4})-(\d{2})$/);
    if (!match) return value || "-";
    const isTh = currentLang() === "th";
    const year = Number(match[1]);
    const monthIdx = Number(match[2]) - 1;
    return `${(isTh ? TH_MONTHS : EN_MONTHS)[monthIdx]} ${year}`;
  };

  formatVisits = (item) => {
    const times = t("pcmr_times");
    if (item.visits_plan === null || item.visits_plan === undefined) return `${item.visits_actual ?? 0} ${times}`;
    return `${item.visits_actual ?? 0} / ${item.visits_plan} ${times}`;
  };

  renderRows() {
    const { data } = this.state;

    if (!data.length) {
      return (
        <tr>
          <td colSpan="6" className="text-center text-secondary py-5">
            {t("pcmr_empty")}
          </td>
        </tr>
      );
    }

    return data.map((item, idx) => {
      const status = STATUS_MAP[item.status];
      return (
        <tr key={`${item.project?.asset_uid || idx}-${item.month}`} className="border-bottom border-light bg-white">
          <td>
            <div className="text-dark text-14 fw-semibold text-nowrap">{this.formatMonth(item.month)}</div>
          </td>
          <td>
            <div className="text-dark text-14">
              {[item.customer?.customer_code, item.customer?.name].filter(Boolean).join(" - ") || "-"}
            </div>
          </td>
          <td>
            <div className="text-dark text-14">
              {[item.project?.asset_code, item.project?.name].filter(Boolean).join(" – ") || "-"}
            </div>
          </td>
          <td>
            <div className="text-dark text-14 text-nowrap">{this.formatVisits(item)}</div>
          </td>
          <td>{status ? Status(t(status.label), status.color) : <span className="text-secondary text-14">{item.status || "-"}</span>}</td>
          <td className="text-end">
            {item.can_print ? (
              <button
                className="btn btn-white border border-primary text-primary px-3 py-1 rounded-3 text-13 text-nowrap"
                onClick={() => this.PrintRow(item)}
              >
                <span className="icon me-1">{""}</span>
                {t("pcmr_print_report")}
              </button>
            ) : null}
          </td>
        </tr>
      );
    });
  }

  render() {
    const {
      data, count, page,
      options_customers, options_projects,
      filter_search, filter_customer_id, filter_asset_id, filter_date_start, filter_date_end,
      modal_batch, batch_plan, batch_total,
    } = this.state;

    const canRead = this.hasPermission("pool_care_report.read");
    const canExport = this.hasPermission("pool_care_report.export");

    // โครงการกรองตามลูกค้าที่เลือก
    const projects = filter_customer_id
      ? options_projects.filter((p) => p.customer_uid === filter_customer_id)
      : options_projects;

    const files = batch_plan?.files || [];

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarAdmin />
        <div className="body p-4 mt-3">
          {/* Header */}
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("pool_care_monthly_report")}</h3>
              <div className="text-secondary text-14">{t("pcmr_desc")}</div>
            </div>
          </div>

          {/* Filter Toolbar */}
          <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
            <div className="row g-3 align-items-end">
              <div className="col-md-3">
                <label className="form-label text-12 text-secondary mb-1">{t("search")}</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={t("pcmr_search_placeholder")}
                  value={filter_search}
                  onChange={(e) => this.setState({ filter_search: e.target.value })}
                  onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                />
              </div>
              <div className="col-md-2">
                <label className="form-label text-12 text-secondary mb-1">{t("customer")}</label>
                <Select
                  className="form-control w-100"
                  options={options_customers}
                  value={filter_customer_id}
                  onChange={(value) => {
                    // เปลี่ยนลูกค้าแล้วโครงการที่เลือกไว้ไม่ใช่ของลูกค้านั้น ต้องล้างทิ้ง
                    const keepProject = options_projects.some((p) => p.value === filter_asset_id && p.customer_uid === value);
                    this.setState({ filter_customer_id: value || "", filter_asset_id: keepProject ? filter_asset_id : "" });
                  }}
                  placeholder={t("all")}
                  defaultLabel={t("all")}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label text-12 text-secondary mb-1">{t("projects")}</label>
                <Select
                  className="form-control w-100"
                  options={projects}
                  value={filter_asset_id}
                  onChange={(value) => this.setState({ filter_asset_id: value || "" })}
                  placeholder={t("all")}
                  defaultLabel={t("all")}
                />
              </div>
              <div className="col-md-4">
                <label className="form-label text-12 text-secondary mb-1">{t("date_range")}</label>
                <div className="d-flex gap-2">
                  <DateRangeFields
                    type={currentLang()}
                    className="form-control"
                    fieldStyle={{ flex: 1, minWidth: 0 }}
                    startPlaceholder={t("start_date")}
                    endPlaceholder={t("end_date")}
                    startValue={filter_date_start}
                    endValue={filter_date_end}
                    onChange={({ start, end }) => this.setState({ filter_date_start: start, filter_date_end: end })}
                  />
                </div>
              </div>
              <div className="col-12 d-flex gap-2 justify-content-end">
                <button className="btn btn-primary px-4 py-2 fw-bold rounded-3" onClick={() => this.Get(1)}>
                  {t("search")}
                </button>
                <ClearFilterButton onClick={this.ResetFilter} />
              </div>
            </div>
          </div>

          {/* Table */}
          <div className="bg-white rounded-4 shadow-sm mb-4 overflow-hidden">
            <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 p-3">
              <h5 className="fw-bold mb-0 text-dark">{t("pcmr_list_title")}</h5>
              {canExport ? (
                <button
                  className="btn btn-primary px-3 py-2 fw-bold rounded-3 d-flex align-items-center"
                  disabled={!batch_total}
                  onClick={this.OpenBatch}
                >
                  <span className="icon me-2">{""}</span>
                  {t("pcmr_print_all")} ({batch_total.toLocaleString()})
                </button>
              ) : null}
            </div>
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0" style={{ minWidth: "900px" }}>
                <thead>
                  <tr className="text-dark fw-bold text-12 border-bottom border-light">
                    <th className="py-3 border-0 wpx-120">{t("pcmr_month")}</th>
                    <th className="py-3 border-0">{t("customer")}</th>
                    <th className="py-3 border-0">{t("projects")}</th>
                    <th className="py-3 border-0 wpx-160">{t("pcmr_visits_on_plan")}</th>
                    <th className="py-3 border-0 wpx-160">{t("status")}</th>
                    <th className="py-3 border-0 text-end wpx-160">{t("pcmr_report")}</th>
                  </tr>
                </thead>
                <tbody>{canRead ? this.renderRows() : null}</tbody>
              </table>
            </div>
          </div>

          {/* Pagination */}
          <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap text-secondary text-12">
            <div>
              {t("showing")} {data.length ? formatNumber((page - 1) * PAGE_SIZE + 1) : 0}-
              {formatNumber((page - 1) * PAGE_SIZE + data.length)} {t("of")} {formatNumber(count)}
            </div>
            <Pagination
              className="mb-0"
              count={Math.ceil(count / PAGE_SIZE) || 1}
              page={page}
              showFirstButton={false}
              showLastButton={false}
              onChange={(_, nextPage) => this.Get(nextPage)}
            />
          </div>
        </div>

        {/* MODAL: Print ทั้งหมด (แบ่งไฟล์ละ <= chunk_size) */}
        <Modal
          show={modal_batch}
          onHide={() => this.setState({ modal_batch: false })}
          centered
          contentClassName="border-0 rounded-4 shadow-lg"
        >
          <Modal.Header className="border-bottom border-light px-4 py-3 bg-white">
            <h5 className="fw-bold mb-0 text-dark">{t("pcmr_batch_title")}</h5>
          </Modal.Header>
          <Modal.Body className="p-0 bg-white">
            <div className="px-4 py-3 text-14">
              {t("pcmr_batch_found")} <b>{(batch_plan?.total || 0).toLocaleString()}</b> {t("pcmr_batch_reports")}
              {" "}{t("pcmr_batch_split")} <b>{files.length.toLocaleString()}</b> {t("pcmr_batch_files")}{" "}
              {t("pcmr_batch_max")} {batch_plan?.chunk_size || 100} {t("pcmr_batch_reports")}
            </div>
            <div style={{ maxHeight: "50vh", overflow: "auto" }} className="border-top border-light">
              {files.map((file) => (
                <div
                  key={file.index}
                  className="d-flex justify-content-between align-items-center gap-2 px-4 py-2 border-bottom border-light"
                >
                  <div>
                    <div className="fw-bold text-dark text-14">
                      {t("pcmr_file")} {file.index}
                    </div>
                    <div className="text-secondary text-12">
                      {t("pcmr_item_no")} {Number(file.from).toLocaleString()}–{Number(file.to).toLocaleString()} (
                      {formatNumber(Number(file.to) - Number(file.from) + 1)} {t("pcmr_batch_reports")})
                    </div>
                  </div>
                  <button
                    className="btn btn-white border border-primary text-primary px-3 py-1 rounded-3 text-13"
                    onClick={() => this.PrintBatchFile(file)}
                  >
                    {t("print")}
                  </button>
                </div>
              ))}
            </div>
          </Modal.Body>
          <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end">
            <button
              className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold"
              onClick={() => this.setState({ modal_batch: false })}
            >
              {t("close")}
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
